<div class="icon" [ngSwitch]="icon" [style.width.px]="automaticWidth" [style.height.px]="automaticHeight">
  <svg *ngSwitchCase="Icon.Close" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path [attr.fill]="color" d="M11.84 10l8 8L18 19.84l-8-8-8 8L.16 18l8-8-8-8L2 .16l8 8 8-8L19.84 2z" />
  </svg>

  <svg *ngSwitchCase="Icon.RoundCaret" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M7.63 2.1c.5-.5.47-1.28-.02-1.73A1.28 1.28 0 0 0 5.77.4L.35 6.15c-.46.47-.46 1.2-.01 1.7l5.44 5.77a1.35 1.35 0 0 0 1.8.06c.54-.48.55-1.25.09-1.75L3.02 6.99l4.61-4.9z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Triangle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 5">
    <path [attr.fill]="color" d="M10 0L5 5 0 0z" />
  </svg>

  <svg *ngSwitchCase="Icon.Arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path
      [attr.fill]="color"
      d="M9.32 14.17V3.2a.65.65 0 1 1 1.29 0v11L14 11a.65.65 0 0 1 1 0 .67.67 0 0 1 0 .93l-4.6 4.2a.63.63 0 0 1-.87 0L5 11.94a.65.65 0 1 1 .87-1z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Search" viewBox="0 0 31 31" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M30.6 28.58l-7.45-7.4a12.87 12.87 0 0 0 2.96-8.21C26.1 5.8 20.26 0 13.05 0 5.84 0 0 5.8 0 12.97c0 7.15 5.84 12.96 13.05 12.96 3.15 0 6.02-1.1 8.27-2.93l7.45 7.4c.5.5 1.32.5 1.83 0 .5-.5.5-1.32 0-1.82zm-17.55-5.23A10.43 10.43 0 0 1 2.6 12.97c0-5.73 4.7-10.4 10.46-10.4 5.77 0 10.47 4.67 10.47 10.4 0 5.72-4.7 10.38-10.47 10.38z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Report" viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg">
    <path [attr.fill]="color" d="M36.16 35.39H.76a.77.77 0 0 0 0 1.54h35.4a.77.77 0 0 0 0-1.54z" />
    <path
      [attr.fill]="color"
      d="M6.92 26.16c.43 0 .77.34.77.77v9.23c0 .42-.34.77-.77.77H2.31a.77.77 0 0 1-.77-.77v-9.23c0-.43.34-.77.77-.77h4.61zm-.77 9.23v-7.7H3.08v7.7h3.07zm10.01-16.93h-4.62a.77.77 0 0 0-.77.77v16.93c0 .42.35.77.77.77h4.62c.42 0 .77-.35.77-.77V19.23a.77.77 0 0 0-.77-.77zm-.77 16.93H12.3V20h3.08v15.4zm10-13.85h-4.62a.77.77 0 0 0-.77.77v13.85c0 .42.35.77.77.77h4.62c.42 0 .77-.35.77-.77V22.3a.77.77 0 0 0-.77-.77zm-.77 13.85h-3.08V23.08h3.08v12.3zm10-23.09H30a.77.77 0 0 0-.77.78v23.08c0 .42.35.77.77.77h4.62c.42 0 .77-.35.77-.77V13.08a.77.77 0 0 0-.77-.77zm-.77 23.09h-3.08V13.85h3.08v21.54zM4.62 13.85a3.08 3.08 0 1 0 0 6.16 3.08 3.08 0 0 0 0-6.16zm0 4.61a1.54 1.54 0 1 1 0-3.08 1.54 1.54 0 0 1 0 3.08zm9.23-12.31a3.08 3.08 0 1 0 0 6.17 3.08 3.08 0 0 0 0-6.17zm0 4.62a1.54 1.54 0 1 1 0-3.08 1.54 1.54 0 0 1 0 3.08zm9.23-1.54a3.08 3.08 0 1 0 0 6.16 3.08 3.08 0 0 0 0-6.16zm0 4.62a1.54 1.54 0 1 1 0-3.08 1.54 1.54 0 0 1 0 3.08zM32.31 0a3.08 3.08 0 1 0 0 6.16 3.08 3.08 0 0 0 0-6.16zm0 4.62a1.54 1.54 0 1 1 0-3.08 1.54 1.54 0 0 1 0 3.08z"
    />
    <path
      [attr.fill]="color"
      d="M31.23 4.16a.77.77 0 0 0-1.1 0l-5.96 5.97a.77.77 0 0 0 1.09 1.1l5.97-5.98c.3-.3.3-.79 0-1.09zm-10.01 6.37l-4.94-1.4a.77.77 0 1 0-.42 1.48L20.8 12a.77.77 0 0 0 .95-.53.77.77 0 0 0-.53-.95zm-8.57-.33a.77.77 0 0 0-1.08-.13l-5.8 4.62a.77.77 0 0 0 .96 1.2l5.8-4.62a.77.77 0 0 0 .12-1.08z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Refresh" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      [attr.fill]="color"
      d="M8.06 0A7.9 7.9 0 0 1 16 7.84v.71c0 .4-.32.71-.72.71s-.72-.32-.72-.7v-.72a6.42 6.42 0 0 0-4.18-5.98 6.55 6.55 0 0 0-7.15 1.7h1.94a.72.72 0 0 1 0 1.43h-3.6a.72.72 0 0 1-.73-.71V.7c0-.4.33-.71.72-.71.4 0 .73.32.73.71v1.76A7.97 7.97 0 0 1 8.06 0zm6.38 11.01c.4 0 .72.32.72.71v3.57c0 .39-.33.7-.72.7a.72.72 0 0 1-.73-.7v-1.76a8 8 0 0 1-8.7 1.92A7.83 7.83 0 0 1 0 8.16v-.71c0-.4.32-.71.72-.71.4 0 .72.32.72.7v.72a6.42 6.42 0 0 0 4.18 5.98c2.51.95 5.36.27 7.15-1.7h-1.94a.72.72 0 0 1-.72-.72c0-.39.32-.7.72-.7h3.6z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Calendar" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M19.22 13.75c.43 0 .78-.35.78-.78V4.69c0-1.73-1.4-3.12-3.13-3.13h-1.01V.78a.78.78 0 1 0-1.56 0v.78h-3.56V.78a.78.78 0 1 0-1.56 0v.78H5.66V.78a.78.78 0 1 0-1.56 0v.78h-.97A3.13 3.13 0 0 0 0 4.7v12.19C0 18.6 1.4 20 3.13 20h13.75C18.6 20 20 18.6 20 16.87a.78.78 0 0 0-1.56 0c0 .87-.7 1.57-1.57 1.57H3.13c-.86 0-1.56-.7-1.56-1.57V4.7c0-.86.7-1.57 1.56-1.57h.98v.79a.78.78 0 1 0 1.56 0v-.79h3.52v.79a.78.78 0 1 0 1.56 0v-.79h3.56v.79a.78.78 0 1 0 1.56 0v-.79h1.02c.86 0 1.56.7 1.56 1.57v8.28c0 .43.35.78.78.78"
    />
    <path [attr.fill]="color" d="M5.66 8.2a.78.78 0 1 0-1.56 0 .78.78 0 0 0 1.56 0" />
  </svg>

  <svg *ngSwitchCase="Icon.Warning" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path
      [attr.fill]="color"
      fill-rule="evenodd"
      d="M16.73 19.2H3.25a3.21 3.21 0 0 1-2.81-1.62 3.21 3.21 0 0 1 0-3.25L7.18 2.66a3.21 3.21 0 0 1 2.81-1.62c1.18 0 2.23.6 2.81 1.62l6.74 11.67a3.21 3.21 0 0 1 0 3.25 3.21 3.21 0 0 1-2.8 1.62zM8.82 7.11a1.18 1.18 0 0 1 2.35 0v3.82c0 .65-.53 1.18-1.18 1.18a1.18 1.18 0 0 1-1.17-1.18V7.1zm1.17 8.47a1.2 1.2 0 1 1 0-2.42 1.2 1.2 0 0 1 0 2.42z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Pencil" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      transform="translate(-6 -6)"
      d="M17.37 8.6l4.03 4.03-11.24 11.25a.4.4 0 0 1-.3.12H6.42a.4.4 0 0 1-.41-.4v-3.47c0-.1.04-.21.12-.29L17.37 8.6zm2.6-2.6L24 10.04l-2.02 2.02-4.04-4.04L19.96 6z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.PDF" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110 110">
    <path
      [attr.fill]="color"
      d="M45.5 34.12a4.61 4.61 0 0 0-4.63-4.63H4.62A4.61 4.61 0 0 0 0 34.12v15.25a4.61 4.61 0 0 0 4.62 4.62h36.25a4.61 4.61 0 0 0 4.62-4.62V34.12zm-31.13 8.37a6.6 6.6 0 0 1-4.25 1.25H9.5V49h-3V35l.62-.12c1.25-.25 2.5-.38 3.5-.38 1.75 0 3.13.38 4 1.13 1 .87 1.63 1.87 1.63 3.25-.13 1.62-.63 2.75-1.88 3.62zm-3.87-5.12h-1v3.5c.12 0 .62.12.87.12 2.5 0 2.75-1 2.75-1.87 0-.5 0-1.75-2.62-1.75zm16.74 9c-1.24 1.5-3.12 2.37-5.62 2.37-.75 0-1.87-.12-3.5-.25l-.37-.12V34.99l.37-.12c2-.25 3.25-.38 4-.38 2.38 0 4.13.75 5.25 2.13 1 1.12 1.37 2.75 1.37 4.62 0 2.25-.5 3.88-1.5 5.13zm-5.24-9c-.38 0-.88 0-1.63.12V46h1.5c1.5 0 2.5-.5 3.13-1.5.5-.75.75-1.75.75-3 0-2.87-1.25-4.12-3.75-4.12zm17 .12h-6v2.63h5.5v3H33v5.87h-3.13V34.87h9.12v2.62zM48 0l30.24 30.37v55.86c0 2.63-2 4.75-4.63 4.75H54.5l2.62-3.37c.13-.13.13-.25.25-.38h14a3.1 3.1 0 0 0 3.13-3.12V30.49H52.62a4.8 4.8 0 0 1-4.63-4.74V3.87H16.87A3.1 3.1 0 0 0 13.75 7v20.12H9.87V4.62c0-2.5 2.13-4.5 4.75-4.5H48V0zM30.86 87.36c.12.12.25.25.25.37l2.62 3.38H14.62a4.75 4.75 0 0 1-4.75-4.75V56.1h3.88v28.12a3.1 3.1 0 0 0 3.12 3.13h14zm23.37-2.88c1 0 1.62 1.13.87 1.88L45 99.6c-.5.62-1.5.62-2 0L32.87 86.36c-.63-.75 0-1.88 1-1.88h5V67.24c0-1.13 1-2.13 2.12-2.13h6.25c1.13 0 2 1 2 2.13v17.24h5z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.NoContract" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 98">
    <path
      [attr.fill]="color"
      d="M81.97 0H24.78a5.94 5.94 0 0 0-5.93 5.94v13.29A26 26 0 0 0 .03 44.18a26 26 0 0 0 18.82 24.96V92a5.94 5.94 0 0 0 5.93 5.94h46.74c.55 0 1.08-.22 1.47-.61l14.3-14.3c.4-.4.62-.93.62-1.49V5.94A5.94 5.94 0 0 0 81.97 0zM24.78 4.18h57.19c.97 0 1.75.79 1.75 1.76v6.31h-60.7V5.94c0-.97.8-1.76 1.76-1.76zm-20.57 40c0-12 9.77-21.77 21.76-21.77 12 0 21.76 9.77 21.76 21.77s-9.76 21.77-21.76 21.77c-12 0-21.76-9.76-21.76-21.77zM23.03 92V69.97a25.88 25.88 0 0 0 22.5-8.75h12.8a2.1 2.1 0 0 0 0-4.18H48.5a25.77 25.77 0 0 0 3.32-10.6h6.51a2.1 2.1 0 0 0 0-4.19h-6.49a25.77 25.77 0 0 0-3.16-10.6h9.65a2.1 2.1 0 0 0 0-4.19H45.8a25.89 25.89 0 0 0-22.77-9.06v-1.97h60.7v63.02h-8.37a5.94 5.94 0 0 0-5.94 5.94v8.37H24.78c-.97 0-1.75-.8-1.75-1.76zm50.58-1.2v-5.41c0-.97.78-1.76 1.75-1.76h5.4l-7.15 7.17z"
    />
    <path
      [attr.fill]="color"
      d="M66.55 31.64h6.94a2.1 2.1 0 0 0 0-4.18h-6.94a2.1 2.1 0 0 0 0 4.18zm0 14.8h6.94a2.1 2.1 0 0 0 0-4.19h-6.94a2.1 2.1 0 0 0 0 4.18zm0 14.78h6.94a2.1 2.1 0 0 0 0-4.18h-6.94a2.1 2.1 0 0 0 0 4.18zm6.94 14.79a2.1 2.1 0 0 0 0-4.18H53.93a2.1 2.1 0 0 0 0 4.18H73.5z"
    />
    <path
      [attr.fill]="color2"
      d="M36.14 51.01a2.92 2.92 0 1 1-4.13 4.13l-6.01-6-6.01 6a2.92 2.92 0 1 1-4.13-4.13l6-6.01-6-6.01a2.92 2.92 0 1 1 4.13-4.13l6.01 6 6.01-6a2.92 2.92 0 1 1 4.13 4.13l-6 6.01 6 6.01z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.More" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
    <path
      [attr.fill]="color"
      d="M0 21V0h5.26v2.06H2.22v16.88h3.04V21H0zm14.86-9.46v5.96H12.3v-5.96H7V9.22h5.3V3.5h2.56v5.72h5.27v2.32h-5.27zM22.74 21v-2.06h3.04V2.06h-3.04V0H28v21h-5.26z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.RoundCheck" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
    <path
      [attr.fill]="color"
      d="M60 10c-27.58 0-50 22.42-50 50s22.42 50 50 50 50-22.42 50-50-22.42-50-50-50zm0 93.9A43.94 43.94 0 0 1 16.1 60 43.94 43.94 0 0 1 60 16.1 43.94 43.94 0 0 1 103.9 60 43.94 43.94 0 0 1 60 103.9zM83.16 44.2L53.58 73.8 38.53 58.74c-1.48-1.48-3.9-1.48-5.37 0s-1.48 3.9 0 5.37l17.68 17.68a3.82 3.82 0 0 0 5.48 0l32.2-32.21c1.48-1.47 1.48-3.9 0-5.37s-3.78-1.47-5.36 0z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.RoundWarning" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
    <path
      [attr.fill]="color"
      d="M60 10c-27.66 0-50 22.49-50 50 0 27.66 22.49 50 50 50 27.66 0 50-22.49 50-50 0-27.66-22.34-50-50-50zm0 92.9c-23.67 0-42.9-19.23-42.9-42.9S36.33 17.1 60 17.1A42.93 42.93 0 0 1 102.9 60 42.93 42.93 0 0 1 60 102.9zm0-20.27a3.5 3.5 0 0 0 2.81-1.18A3.79 3.79 0 0 0 64 78.64c0-1.04-.44-2.07-1.18-2.81a4.11 4.11 0 0 0-5.62 0 4.04 4.04 0 0 0-1.18 2.8c0 1.2.44 2.08 1.03 2.82A4.13 4.13 0 0 0 60 82.63zm0-16.27c2.22 0 4-1.77 4-4v-21c0-2.22-1.78-4-4-4-2.22 0-4 1.78-4 4v21c0 2.23 1.78 4 4 4z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Less" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
    <path
      [attr.fill]="color"
      d="M0 21V0h5.26v2.06H2.22v16.88h3.04V21H0zm7-9.46V9.22h13.13v2.32H7zM22.74 21v-2.06h3.04V2.06h-3.04V0H28v21h-5.26z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Help" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M7.2 12.8h1.6v-1.6H7.2v1.6zM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14.4a6.4 6.4 0 1 1 .02-12.82A6.4 6.4 0 0 1 8 14.4zM8 3.2a3.2 3.2 0 0 0-3.2 3.2h1.6c0-.88.72-1.6 1.6-1.6.88 0 1.6.72 1.6 1.6 0 1.6-2.4 1.4-2.4 4h1.6c0-1.8 2.4-2 2.4-4A3.2 3.2 0 0 0 8 3.2z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Health" viewBox="0 0 93 93" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M2.11 65.95h24.94v24.94c0 1.16.94 2.11 2.11 2.11h34.68c1.17 0 2.11-.95 2.11-2.11V65.95H90.9c1.16 0 2.11-.95 2.11-2.11V29.15c0-1.16-.95-2.11-2.11-2.11H65.95V2.11C65.95.95 65.01 0 63.84 0H29.16C28 0 27.05.95 27.05 2.11v24.93H2.1c-1.16 0-2.11.95-2.11 2.11v34.69c0 1.16.95 2.11 2.11 2.11zm2.12-34.68h24.93c1.17 0 2.11-.95 2.11-2.12V4.23h30.46v24.92c0 1.17.94 2.12 2.11 2.12h24.93v30.45H63.84c-1.17 0-2.11.95-2.11 2.12v24.93H31.27V63.84c0-1.17-.94-2.12-2.11-2.12H4.23V31.27z"
    />
    <path
      d="M36.22 58.68c3.4 2.8 6.57 5.43 7.73 8.67.2.91.98 1.58 1.9 1.64h.06l.11.01h.18a2.1 2.1 0 0 0 1.85-1.65c1.17-3.24 4.33-5.87 7.73-8.67 3.47-2.86 7.3-6.01 8.04-10.98 1.03-6.95-2.56-11.71-7.04-13.14A11.53 11.53 0 0 0 46 36.5a11.11 11.11 0 0 0-7.32-2.5c-1.17.02-2.34.2-3.46.56-4.48 1.43-8.07 6.2-7.04 13.14.74 4.97 4.57 8.12 8.04 10.98zm.26-20.11c.7-.22 1.45-.33 2.2-.33 2.24 0 4.5.97 5.6 2.55a2.09 2.09 0 0 0 3.43 0c1.47-2.1 5-3.11 7.8-2.22 2.8.89 4.98 3.05 4.17 8.51-.45 3.04-3.13 5.53-6.55 8.35-2.42 2-5.16 4.1-7.13 6.9-1.97-2.8-4.7-4.9-7.13-6.9-3.42-2.82-6.1-5.3-6.55-8.35-.81-5.46 1.36-7.62 4.16-8.51z"
      [attr.fill]="color2"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Caret" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M7.66 6.38a.42.42 0 0 1 0 .61l-6.24 6.24a.42.42 0 0 1-.62 0l-.67-.67a.42.42 0 0 1 0-.61L5.4 6.68.13 1.42a.42.42 0 0 1 0-.62L.8.13a.42.42 0 0 1 .62 0l6.24 6.25z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Filter" viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg">
    <path [attr.fill]="color" d="M6.22 10.67h3.56V8.89H6.22v1.78zM0 0v1.78h16V0H0zm2.67 6.22h10.66V4.44H2.67v1.78z" />
  </svg>

  <svg *ngSwitchCase="Icon.Eye" viewBox="0 0 30 21" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M29.3 9.95a1.4 1.4 0 0 1-2.6 1.07 12.67 12.67 0 0 0-23.4 0A1.4 1.4 0 1 1 .7 9.95a15.49 15.49 0 0 1 28.6 0zM15 20.08a7.03 7.03 0 1 1 0-14.06 7.03 7.03 0 0 1 0 14.06zm0-2.8a4.22 4.22 0 1 0 0-8.44 4.22 4.22 0 0 0 0 8.43z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Document" viewBox="0 0 26 32" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M22.98 31.74H2.32a1.8 1.8 0 0 1-1.82-1.8V2.8C.5 1.8 1.31 1 2.32 1h20.66c1.01 0 1.82.8 1.82 1.8v27.13c-.1 1-.81 1.81-1.82 1.81zM2.32 2.61c-.1 0-.3.1-.3.3v27.12c0 .1.1.3.3.3h20.66c.1 0 .3-.1.3-.3V2.91c0-.1-.1-.3-.3-.3H2.32zm4.15 4.42h12.26v1.5H6.47v-1.5zm0 5.72h12.26v1.51H6.47v-1.5zm0 5.73h12.26v1.5H6.47v-1.5zm0 5.73h12.26v1.5H6.47v-1.5z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Dashboard" viewBox="0 0 39 24" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M33.6 18.31H36.82a17.23 17.23 0 0 0-17.15-16.2c-9.11 0-16.6 7.17-17.14 16.2h12.66a4.61 4.61 0 0 1 5.86-3.36l3.11-5.28c.3-.5.94-.67 1.44-.37.5.3.66.94.37 1.45l-3.11 5.28c.63.6 1.09 1.4 1.3 2.28h9.44zm-12.54-1.04a1.03 1.03 0 0 1-.23-.14 2.51 2.51 0 1 0-1.15 4.75 2.51 2.51 0 0 0 1.38-4.6zm-5.87 3.15H1.45c-.58 0-1.05-.47-1.05-1.06A19.34 19.34 0 0 1 19.67 0a19.34 19.34 0 0 1 19.28 19.36c0 .59-.47 1.06-1.05 1.06H24.16a4.62 4.62 0 0 1-4.49 3.57c-2.17 0-4-1.53-4.48-3.57zm4.48-13.99c-.57 0-1.04-.47-1.04-1.05V4.1a1.05 1.05 0 1 1 2.1 0v1.27c0 .58-.48 1.05-1.06 1.05zm-9.84 4.1c-.27 0-.54-.1-.74-.31l-.9-.9a1.06 1.06 0 0 1 .01-1.48 1.05 1.05 0 0 1 1.48 0l.89.89a1.06 1.06 0 0 1-.74 1.8zm19.69 0a1.06 1.06 0 0 1-.74-1.8l.89-.9a1.05 1.05 0 0 1 1.48 0c.4.42.4 1.09 0 1.5l-.89.89c-.2.2-.47.3-.74.3zM14.4 7.47c-.41 0-.8-.25-.97-.66l-.48-1.17a1.05 1.05 0 1 1 1.94-.8l.48 1.18a1.05 1.05 0 0 1-.97 1.45zM6.84 15c-.14 0-.27-.03-.4-.08l-1.17-.5a1.06 1.06 0 0 1-.56-1.37c.23-.54.84-.79 1.38-.56l1.16.49A1.06 1.06 0 0 1 6.84 15zm18.22-7.48a1.06 1.06 0 0 1-.97-1.46l.5-1.16c.22-.54.83-.8 1.37-.56.53.22.78.84.56 1.37l-.49 1.17c-.17.4-.56.64-.97.64zm7.5 7.6c-.41 0-.8-.24-.97-.65-.22-.53.04-1.15.57-1.37l1.17-.48a1.05 1.05 0 1 1 .8 1.95l-1.17.48c-.13.05-.26.08-.4.08z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Check" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M3.13 10.37l1.19-1.01 3.24 3.78c.17.2.46.21.66.05l8.09-8.04 1.1 1.1-8.07 8.02a2.03 2.03 0 0 1-.1.1c-.86.73-2.14.63-2.87-.22l-3.24-3.78z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.RoundFillCheck" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M8.16 15.14l-4.4-4.4 1.47-1.47 2.93 2.94 6.6-6.6 1.46 1.47-8.06 8.06zM9.99.02A9.99 9.99 0 1 0 10 20 9.99 9.99 0 0 0 10 .02z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Logo" viewBox="0 0 29 31" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M13.99.3c.16-.14.38-.46.6-.2 1.53 1.44 3.11 2.83 4.59 4.34-.6.74-1.2 1.47-1.78 2.22.27.2.6.3.9.44l3.78 1.62 3.13-2.08c-.63-.72-1.31-1.39-1.9-2.13 1.79-1.29 3.55-2.63 5.4-3.85-.23 3.02-.57 6.04-.85 9.06H.94C.64 6.69.37 3.65 0 .62c1.9 1.22 3.67 2.61 5.52 3.9a89.51 89.51 0 0 1-1.93 2.1c1.04.71 2.09 1.4 3.13 2.1l4.7-2.01c-.57-.79-1.2-1.52-1.8-2.28C11.03 3 12.54 1.68 14 .3zM1.14 11.4h26.49c-.08 1-.18 1.98-.25 2.97h-9.96v10.55l4.3-.01c.4-.05.84.05 1.23-.14.65-.25 1.26-.8 1.38-1.5-.18-1.18-1.23-1.94-2.18-2.51 1.71-1.07 3.37-2.24 5.03-3.4-.41 3.12-.78 6.25-1.19 9.37-3.87 1.42-7.74 2.83-11.6 4.27-3.85-1.46-7.72-2.84-11.58-4.28l-1.17-9.35c1.65 1.15 3.3 2.3 5 3.39-.83.52-1.73 1.12-2.06 2.1-.26.56.12 1.17.57 1.51.38.27.82.55 1.3.52 1.65.06 3.3.02 4.95.03V14.38H1.44l-.3-2.97z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.RoundNoContract" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
    <path
      [attr.fill]="color"
      d="M10.43.14A10.56 10.56 0 0 0 0 10.83c0 5.9 4.67 10.69 10.43 10.69s10.43-4.79 10.43-10.7C20.86 4.93 16.2.15 10.43.15"
    />
    <path
      [attr.fill]="color2"
      d="M13.2 14.85a.81.81 0 0 1-1.16 0l-1.23-1.26-1.22 1.25a.81.81 0 0 1-1.17 0 .86.86 0 0 1 0-1.19l1.22-1.26-1.22-1.25a.86.86 0 0 1 0-1.2.81.81 0 0 1 1.17 0l1.22 1.26 1.23-1.26a.81.81 0 0 1 1.16 0 .86.86 0 0 1 0 1.2l-1.22 1.25 1.22 1.26a.86.86 0 0 1 0 1.2M14.83 4.1H9.8v3.21a.38.38 0 0 1-.38.38H6.26v8.9a.54.54 0 0 0 .54.55h8.03a.54.54 0 0 0 .53-.55V4.66a.54.54 0 0 0-.53-.55"
    />
    <path [attr.fill]="color2" d="M9.05 4.49L6.64 6.94h2.4z" />
  </svg>

  <svg *ngSwitchCase="Icon.RoundNoSign" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
    <path [attr.fill]="color" d="M10.3.13a10.12 10.12 0 1 0 0 20.25 10.12 10.12 0 0 0 0-20.25" />
    <path
      [attr.fill]="color2"
      d="M10.5 5.7l2.63 2.64-7.33 7.33a.27.27 0 0 1-.19.08H3.35a.27.27 0 0 1-.26-.27v-2.25c0-.07.03-.14.08-.2l7.33-7.32zm1.7-1.69l2.62 2.64-1.31 1.31-1.32-1.32-1.32-1.31 1.32-1.32zm4.23 12.11a.92.92 0 0 1-1.3 0l-1.37-1.37-1.37 1.37a.92.92 0 1 1-1.3-1.3l1.37-1.37-1.37-1.37a.92.92 0 1 1 1.3-1.3l1.37 1.36 1.37-1.36a.92.92 0 1 1 1.3 1.3l-1.37 1.37 1.37 1.36a.92.92 0 0 1 0 1.3"
    />
  </svg>

  <svg *ngSwitchCase="Icon.BoldArrow" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M11.25 12.66l.12-9.45a1.31 1.31 0 0 0-2.62 0l-.12 9.44-2.28-2.21a1.3 1.3 0 0 0-1.86.06 1.33 1.33 0 0 0 .06 1.86L9 16.61a1.3 1.3 0 0 0 1.77 0l4.57-4.14a1.32 1.32 0 0 0 .1-1.85 1.29 1.29 0 0 0-1.85-.11z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Padlock" viewBox="0 0 105 105" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color2"
      d="M68.546 74.059a3.938 3.938 0 1 1 0-7.876 3.938 3.938 0 0 1 0 7.876zm-14.963 0a3.938 3.938 0 1 1 0-7.876 3.938 3.938 0 0 1 0 7.876zm-29.532 0a3.938 3.938 0 1 1 0-7.876 3.938 3.938 0 0 1 0 7.876zm14.766 0a3.938 3.938 0 1 1 0-7.876 3.938 3.938 0 0 1 0 7.876z"
    />
    <path
      [attr.fill]="color"
      d="M48.858 94.928a3.938 3.938 0 1 1 0 7.875H17.75C9.066 102.803 2 95.738 2 87.053V54.764c0-8.684 7.066-15.75 15.75-15.75h4.718V25.127C22.468 12.375 33.067 2 46.094 2 59.121 2 69.72 12.375 69.72 25.127v13.887h4.732c8.685 0 15.75 7.066 15.75 15.75v7.876a3.938 3.938 0 1 1-7.875 0v-7.876c0-4.342-3.532-7.875-7.875-7.875H17.75c-4.342 0-7.875 3.533-7.875 7.875v32.289c0 4.342 3.533 7.875 7.875 7.875h31.108zM30.344 25.127v13.887h31.5V25.127c0-8.41-7.065-15.252-15.75-15.252-8.685 0-15.75 6.842-15.75 15.252zm70.814 41.005a3.938 3.938 0 0 1 .91 5.494L82.58 98.846c-.043.06-.087.118-.133.175a10.152 10.152 0 0 1-7.886 3.782c-2.587 0-5.102-.997-6.985-2.79l-.036-.035-12.565-12.262a3.937 3.937 0 1 1 5.5-5.636l12.543 12.24a2.23 2.23 0 0 0 1.687.603 2.23 2.23 0 0 0 1.55-.771l19.409-27.11a3.937 3.937 0 0 1 5.494-.91z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Download" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M8.716 18.465V1.72a.986.986 0 1 1 1.97 0v16.73l5.225-4.859a.974.974 0 0 1 1.391.062c.367.408.34 1.04-.061 1.413l-6.884 6.4a.973.973 0 0 1-1.33 0l-6.883-6.4a1.011 1.011 0 0 1-.062-1.413.974.974 0 0 1 1.392-.062l5.242 4.874zM0 24.015c0-.543.436-.984.992-.984h18.016a.986.986 0 1 1 0 1.969H.992A.986.986 0 0 1 0 24.015z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.RoundLess" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
    <path [attr.fill]="color" d="M20.72,13.85H9.28a1.15,1.15,0,0,0,0,2.3H20.72a1.15,1.15,0,1,0,0-2.3Z" />
    <path
      [attr.fill]="color"
      d="M15,.18A14.82,14.82,0,1,0,29.82,15,14.84,14.84,0,0,0,15,.18ZM27.52,15A12.52,12.52,0,1,1,15,2.48,12.54,12.54,0,0,1,27.52,15Z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.RoundMore" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M15,.18A14.82,14.82,0,1,0,29.82,15,14.84,14.84,0,0,0,15,.18ZM27.52,15A12.52,12.52,0,1,1,15,2.48,12.54,12.54,0,0,1,27.52,15Z"
    />
    <path
      [attr.fill]="color"
      d="M20.72,13.85H16.15V9.28a1.15,1.15,0,0,0-2.3,0v4.57H9.28a1.15,1.15,0,0,0,0,2.3h4.57v4.57a1.15,1.15,0,0,0,2.3,0V16.15h4.57a1.15,1.15,0,1,0,0-2.3Z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Flag" viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M10.384 0C4.866 0 .392 4.474.392 9.992c0 5.519 4.474 9.992 9.992 9.992 5.519 0 9.992-4.473 9.992-9.992C20.376 4.474 15.903 0 10.384 0z"
    />
    <path [attr.fill]="color2" d="M7.792 4.673V4.2a.2.2 0 0 0-.4 0v11.6a.2.2 0 0 0 .4 0V4.673z" />
    <path stroke-linejoin="round" [attr.fill]="color2" d="M7.792 11.707V5.113l7.692 3.572z" />
  </svg>

  <svg *ngSwitchCase="Icon.ProfilePhoto" viewBox="0 0 160 155" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M116 69.4l-2.6-.3V9.3c0-1.9-1.5-3.4-3.4-3.4H9.3c-1.9 0-3.4 1.5-3.4 3.4v101c0 1.9 1.5 3.4 3.4 3.4h60l.4 2.5c2.8 20.4 20.5 35.8 41 35.8 22.8 0 41.4-18.6 41.4-41.5 0-20.8-15.5-38.5-36.1-41.1zm-45 29c-.6 2-1 4-1.3 6l-.3 2.6H12.6V12.6H107v56.5l-2.9.5c-4.6.7-8.9 2.2-12.9 4.3-3.7-4.6-9.3-7.6-15.6-7.6H42.2c-11.1 0-20 9.1-20 20.3v6.8H73c-.6 1.3-1.1 2.6-1.6 3.9l-.4 1.1zm6.2-12.3H28.8c0-7.3 6-13.2 13.4-13.2h33.5c4 0 7.6 1.8 10.1 4.5-3.3 2.5-6.2 5.4-8.6 8.7zm33.4 59.2c-19.1 0-34.6-15.6-34.6-34.7v-.2c.1-19.1 15.6-34.6 34.6-34.6 19.1 0 34.6 15.6 34.6 34.7.1 19.2-15.5 34.8-34.6 34.8z"
    />
    <path
      [attr.fill]="color2"
      d="M58.6 59.6C68.7 59.6 77 51.3 77 41s-8.2-18.6-18.4-18.6S40.2 30.7 40.2 41s8.2 18.6 18.4 18.6zm0-30.6c6.5 0 11.7 5.3 11.7 11.7 0 6.5-5.3 11.7-11.7 11.7s-11.7-5.3-11.7-11.7C46.8 34.2 52.1 29 58.6 29zM127 106.4h-13v-13c0-1.8-1.5-3.3-3.3-3.3-1.8 0-3.3 1.5-3.3 3.3v13h-13c-1.8 0-3.3 1.5-3.3 3.3 0 1.8 1.5 3.3 3.3 3.3h13v13c0 1.8 1.5 3.3 3.3 3.3 1.8 0 3.3-1.5 3.3-3.3v-13h13c1.8 0 3.3-1.5 3.3-3.3 0-1.8-1.4-3.3-3.3-3.3z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.PhotoCamera" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
    <path
      [attr.fill]="color"
      d="M1 6.508c0-1.416 1.145-2.575 2.555-2.575h3.57l.084-.376A3.277 3.277 0 0 1 10.406 1h3.183a3.27 3.27 0 0 1 3.197 2.557l.085.376h3.574A2.567 2.567 0 0 1 23 6.508v9.785C23 17.787 21.797 19 20.315 19H3.685C2.203 19 1 17.787 1 16.293V6.508zm6.564-1.466h-4.01A1.46 1.46 0 0 0 2.1 6.508v9.785c0 .883.71 1.598 1.585 1.598H20.31c.875 0 1.585-.715 1.585-1.598V6.508a1.46 1.46 0 0 0-1.455-1.466h-4.01a.553.553 0 0 1-.534-.43l-.184-.806A2.175 2.175 0 0 0 13.59 2.11h-3.183c-1.02 0-1.89.697-2.124 1.697l-.184.806a.548.548 0 0 1-.534.43zm-2.842 3.11a.74.74 0 0 1-.736-.743c0-.41.33-.742.736-.742a.74.74 0 0 1 .736.742.74.74 0 0 1-.736.742zM12 16.152c-2.546 0-4.62-2.086-4.62-4.657 0-2.57 2.074-4.657 4.62-4.657 2.546 0 4.62 2.09 4.62 4.657 0 2.566-2.074 4.657-4.62 4.657zm0-8.206c-1.94 0-3.52 1.594-3.52 3.549 0 1.955 1.58 3.548 3.52 3.548s3.52-1.593 3.52-3.548S13.94 7.947 12 7.947z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.StarFull" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 35">
    <path
      [attr.fill]="color"
      fill-rule="nonzero"
      d="M7.27 34a.65.65 0 0 1-.38-.12.64.64 0 0 1-.25-.63l1.99-11.5L.19 13.6a.64.64 0 0 1 .36-1.1l11.66-1.67L17.42.36a.64.64 0 0 1 1.15 0l5.22 10.47 11.66 1.68a.63.63 0 0 1 .36 1.09l-8.44 8.15 1.99 11.5a.64.64 0 0 1-.93.67L18 28.5 7.57 33.93c-.1.05-.2.07-.3.07z"
    />
  </svg>

  <svg *ngSwitchCase="Icon.StarOutline" viewBox="0 0 37 35">
    <path
      d="M10.75 22.054c.06-.338-.053-.682-.3-.922l-7.156-6.914 9.893-1.424a1.05 1.05 0 0 0 .786-.566L18.4 3.336l4.428 8.89c.153.306.447.517.786.566l9.892 1.425-7.156 6.915c-.246.24-.36.584-.3.92l1.7 9.766-8.853-4.614a1.04 1.04 0 0 0-.97 0L9.06 31.82l1.7-9.766zm25.998-8.884a1.04 1.04 0 0 0-.844-.704l-11.45-1.65-5.12-10.28c-.35-.712-1.518-.714-1.87-.002l-5.12 10.283-11.45 1.65a1.04 1.04 0 0 0-.844.706 1.05 1.05 0 0 0 .266 1.067L8.6 22.24 6.644 33.538a1.04 1.04 0 0 0 .414 1.017c.313.228.753.262 1.1.08L18.4 29.3l10.24 5.335c.15.08.318.12.485.12a1.04 1.04 0 0 0 1.029-1.215L28.2 22.24l8.282-8.002a1.04 1.04 0 0 0 .266-1.069z"
      [attr.fill]="color"
      fill-rule="evenodd"
    />
  </svg>

  <svg *ngSwitchCase="Icon.Avatar" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
    <path
      fill="none"
      [attr.stroke]="color"
      stroke-width="3"
      d="M17 15.5a9.5 9.5 0 1 1 19 0 9.5 9.5 0 0 1-19 0zM5 46v-2.8C5 37.02 10.38 32 17 32h19c6.62 0 12 5.02 12 11.2V46H5zh43H5z"
    />
  </svg>
  <svg *ngSwitchCase="Icon.Device" viewBox="0 0 44 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.584 3.88688V44.2197C30.584 45.6298 29.4406 46.7733 28.0304 46.7733H3.36909C1.95682 46.7733 0.813354 45.6298 0.813354 44.2197V3.88688C0.813354 2.47675 1.95682 1.33328 3.36909 1.33328H28.0304C29.4406 1.33328 30.584 2.47675 30.584 3.88688ZM26.4966 38.2421V9.67888H4.90082V38.2421H26.4966ZM17.752 42.5621C17.752 41.6063 16.9776 40.8319 16.0219 40.8319C15.0662 40.8319 14.2918 41.6063 14.2918 42.5621C14.2918 43.5178 15.0662 44.2922 16.0219 44.2922C16.9776 44.2922 17.752 43.5178 17.752 42.5621Z"
      fill="white"
    />
    <path d="M26.4624 9.70663H4.86664V38.2698H26.4624V9.70663Z" fill="#C1D6EA" />
    <path
      d="M16.0219 44.2923C16.9774 44.2923 17.752 43.5177 17.752 42.5622C17.752 41.6066 16.9774 40.832 16.0219 40.832C15.0664 40.832 14.2917 41.6066 14.2917 42.5622C14.2917 43.5177 15.0664 44.2923 16.0219 44.2923Z"
      fill="white"
    />
    <path
      d="M28.0304 46.7733H3.36909C1.95682 46.7733 0.813354 45.6298 0.813354 44.2197V3.88688C0.813354 2.47675 1.95682 1.33328 3.36909 1.33328H28.0304C29.4406 1.33328 30.584 2.47675 30.584 3.88688V44.2197C30.584 45.6298 29.4406 46.7733 28.0304 46.7733Z"
      stroke="#0C1751"
      stroke-width="0.746667"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.1611 5.62781H18.2363"
      stroke="#0C1751"
      stroke-width="0.746667"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.0219 44.2923C16.9774 44.2923 17.752 43.5177 17.752 42.5622C17.752 41.6066 16.9774 40.832 16.0219 40.832C15.0664 40.832 14.2917 41.6066 14.2917 42.5622C14.2917 43.5177 15.0664 44.2923 16.0219 44.2923Z"
      stroke="#0C1751"
      stroke-width="0.746667"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M43.352 16.6953V31.3047C43.352 32.5717 42.3963 33.6 41.2187 33.6H19.3733C18.1936 33.6 17.24 32.5717 17.24 31.3047V16.6953C17.24 15.4283 18.1936 14.4 19.3733 14.4H41.2187C42.3963 14.4 43.352 15.4283 43.352 16.6953Z"
      fill="#1673AF"
    />
    <path
      d="M43.2666 16.6953V31.3047C43.2666 32.5717 42.3609 33.6 41.2449 33.6H30.8933V14.4H41.2449C42.3609 14.4 43.2666 15.4283 43.2666 16.6953Z"
      fill="#6FBCE8"
    />
    <path
      d="M33.4533 26.3467L34.7087 27.6267L37.08 25.0667"
      stroke="#0C1751"
      stroke-width="0.746667"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M41.1403 33.6H19.3664C18.1905 33.6 17.24 32.5717 17.24 31.3047V16.6953C17.24 15.4283 18.1905 14.4 19.3664 14.4H41.1403C42.314 14.4 43.2667 15.4283 43.2667 16.6953V31.3047C43.2667 32.5717 42.314 33.6 41.1403 33.6Z"
      stroke="#0C1751"
      stroke-width="0.746667"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M40.28 22.5066H20.2266V30.1866H40.28V22.5066Z"
      stroke="#0C1751"
      stroke-width="0.746667"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M36.8666 18.6666C36.8666 19.6092 37.6307 20.3733 38.5733 20.3733C39.5159 20.3733 40.28 19.6092 40.28 18.6666C40.28 17.7241 39.5159 16.96 38.5733 16.96C37.6307 16.96 36.8666 17.7241 36.8666 18.6666Z"
      stroke="#0C1751"
      stroke-width="0.746667"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.2266 17.6H33.0266"
      stroke="#0C1751"
      stroke-width="0.746667"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.2266 19.7333H30.8932"
      stroke="#0C1751"
      stroke-width="0.746667"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M25.3466 22.5066L25.3466 29.9733"
      stroke="#0C1751"
      stroke-width="0.746667"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30.6799 22.5066L30.6799 29.9733"
      stroke="#0C1751"
      stroke-width="0.746667"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <ng-container *ngSwitchDefault>error</ng-container>
</div>
